/**
 * Created by pery on 22/07/2015.
 */
module.exports = function postLinkSwitch(scope, element, attr, ctrl, transcludeFn) {
    scope.toggleMenu = function () {
        element.toggleClass('open');
    }
};
